import React, { useMemo } from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { eventConditionsPrimitiveSelector } from '../../../../../redux/selectors/builder';
import { IRowMeta } from '../../../../../redux/slices/oldBuilder';
import DndDroppableZone from '../../../../DndEntity/DndDroppableZone';
import { createDictionaryEntityDropzoneId } from '../../../../DndEntity/utils';
import {
  EntityDropzoneDataTypeEnum,
  IEventEntityDropzoneDataType,
} from '../../../../DndEntity/validation';
import { EntityDropzoneType } from '../../../../QuickAccessDictionary/DictionaryTabs/types';
import BuilderSectionCard from '../../../BuilderSectionCard';
import MergeEventInput from './MergeEventInput';

interface IProps {
  index: number;
  rowMeta: IRowMeta;
}

const MergeEvent = ({ index, rowMeta }: IProps) => {
  const mergeEventDropzoneId = createDictionaryEntityDropzoneId(
    EntityDropzoneType.Events,
    rowMeta,
    '-Input',
  );
  const eventConditionSelector = useMemo(eventConditionsPrimitiveSelector, []);
  const eventConditions = useAppSelector((state) =>
    eventConditionSelector(state, rowMeta),
  );

  return (
    <DndDroppableZone
      id={mergeEventDropzoneId}
      accepts={[EntityDropzoneType.Events]}
      data={
        {
          id: mergeEventDropzoneId,
          type: EntityDropzoneDataTypeEnum.Events,
          rowMeta: {
            ...rowMeta,
            eventIndex: eventConditions?.length ?? 0,
          },
          isNewEvent: true,
        } satisfies IEventEntityDropzoneDataType
      }
    >
      <BuilderSectionCard
        iconName="merge-event-active"
        iconPositiveIndex={index + 1}
        gap={8}
      >
        <MergeEventInput index={index} />
      </BuilderSectionCard>
    </DndDroppableZone>
  );
};

export default MergeEvent;
